import { useState } from "react";
import { Send } from "lucide-react";
import { Reveal } from "./Reveal";
import { waLink, WHATSAPP_DISPLAY } from "../lib/constants";

const FIELD =
  "w-full border border-slate-900/15 bg-white px-4 py-3.5 text-sm text-slate-900 outline-none transition-colors placeholder:text-slate-400 focus:border-slate-900";

const initial = {
  nome: "",
  telefone: "",
  tipo: "Residencial térreo",
  terreno: "",
  pavimentos: "1 pavimento",
  orcamento: "Até R$ 300 mil",
  detalhes: "",
};

export const WhatsAppRequestForm = () => {
  const [form, setForm] = useState(initial);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = (e) => {
    e.preventDefault();
    const msg = [
      "*Solicitação de Projeto — ZARI ENGENHARIA*",
      "",
      `*Nome:* ${form.nome}`,
      form.telefone && `*Telefone:* ${form.telefone}`,
      `*Tipo de projeto:* ${form.tipo}`,
      form.terreno && `*Terreno:* ${form.terreno}`,
      `*Pavimentos:* ${form.pavimentos}`,
      `*Orçamento estimado:* ${form.orcamento}`,
      form.detalhes && `*Detalhes:* ${form.detalhes}`,
    ]
      .filter(Boolean)
      .join("\n");
    window.open(waLink(msg), "_blank");
  };

  return (
    <section id="solicitar" className="border-t border-slate-900/10 bg-slate-950 py-24 text-white sm:py-32">
      <div className="mx-auto grid max-w-7xl gap-14 px-5 sm:px-8 lg:grid-cols-2 lg:gap-20">
        <Reveal>
          <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-[#C05621]">Projeto sob medida</p>
          <h2 className="font-display mt-4 text-3xl font-extrabold uppercase leading-[1.02] tracking-tight sm:text-4xl lg:text-5xl">
            Não achou o projeto ideal? Nós desenhamos para você.
          </h2>
          <p className="mt-6 max-w-md text-base text-slate-400">
            Conte as medidas do seu terreno e o que você imagina. Um engenheiro
            responde diretamente no WhatsApp {WHATSAPP_DISPLAY} com orçamento e prazo.
          </p>
          <ul className="mt-8 space-y-3 font-mono text-[11px] uppercase tracking-[0.2em] text-slate-400">
            <li className="flex items-center gap-3"><span className="h-px w-6 bg-[#C05621]" /> Escopo completo: arquitetônico + complementares</li>
            <li className="flex items-center gap-3"><span className="h-px w-6 bg-[#C05621]" /> RRT/ART inclusa</li>
            <li className="flex items-center gap-3"><span className="h-px w-6 bg-[#C05621]" /> Aprovação junto à prefeitura</li>
          </ul>
        </Reveal>

        <Reveal delay={0.15}>
          <form
            data-testid="whatsapp-custom-request-form"
            onSubmit={submit}
            className="space-y-4 border border-white/10 bg-white/[0.03] p-6 sm:p-8"
          >
            <div className="grid gap-4 sm:grid-cols-2">
              <input required data-testid="wa-form-nome" value={form.nome} onChange={set("nome")} placeholder="Seu nome *" className={`${FIELD} !bg-transparent !text-white placeholder:!text-slate-500 !border-white/15 focus:!border-white`} />
              <input data-testid="wa-form-telefone" value={form.telefone} onChange={set("telefone")} placeholder="Seu telefone" className={`${FIELD} !bg-transparent !text-white placeholder:!text-slate-500 !border-white/15 focus:!border-white`} />
            </div>
            <div className="grid gap-4 sm:grid-cols-2">
              <select data-testid="wa-form-tipo" value={form.tipo} onChange={set("tipo")} className={`${FIELD} !bg-slate-950 !text-white !border-white/15`}>
                <option>Residencial térreo</option>
                <option>Sobrado</option>
                <option>Comercial</option>
                <option>Industrial</option>
                <option>Reforma / Ampliação</option>
              </select>
              <input data-testid="wa-form-terreno" value={form.terreno} onChange={set("terreno")} placeholder="Terreno (ex.: 12x30m)" className={`${FIELD} !bg-transparent !text-white placeholder:!text-slate-500 !border-white/15 focus:!border-white`} />
            </div>
            <div className="grid gap-4 sm:grid-cols-2">
              <select data-testid="wa-form-pavimentos" value={form.pavimentos} onChange={set("pavimentos")} className={`${FIELD} !bg-slate-950 !text-white !border-white/15`}>
                <option>1 pavimento</option>
                <option>2 pavimentos</option>
                <option>3+ pavimentos</option>
              </select>
              <select data-testid="wa-form-orcamento" value={form.orcamento} onChange={set("orcamento")} className={`${FIELD} !bg-slate-950 !text-white !border-white/15`}>
                <option>Até R$ 300 mil</option>
                <option>R$ 300 mil – R$ 600 mil</option>
                <option>R$ 600 mil – R$ 1 mi</option>
                <option>Acima de R$ 1 mi</option>
              </select>
            </div>
            <textarea
              data-testid="wa-form-detalhes"
              value={form.detalhes}
              onChange={set("detalhes")}
              rows={4}
              placeholder="Conte o que você imagina: estilo, ambientes, referências…"
              className={`${FIELD} !bg-transparent !text-white placeholder:!text-slate-500 !border-white/15 focus:!border-white`}
            />
            <button
              data-testid="whatsapp-form-submit-btn"
              type="submit"
              className="flex w-full items-center justify-center gap-3 border border-[#25D366] bg-[#25D366] py-4 font-mono text-xs uppercase tracking-[0.2em] text-white transition-colors hover:bg-[#1eb857]"
            >
              <Send size={15} />
              Enviar pelo WhatsApp
            </button>
          </form>
        </Reveal>
      </div>
    </section>
  );
};
